/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { UploadDocumentDto } from '../models/UploadDocumentDto';
import type { UploadImageDto } from '../models/UploadImageDto';
import type { UploadResponseDto } from '../models/UploadResponseDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UploadService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Upload an image file
     * Upload an image file (JPEG, PNG, GIF, WebP) to the server. In production, files are stored in S3. In development, files are stored locally.
     * @param formData Image file to upload
     * @returns UploadResponseDto Image uploaded successfully
     * @throws ApiError
     */
    public uploadControllerUploadImage(
        formData: UploadImageDto,
    ): Observable<UploadResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/upload/image',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request - invalid file or file type not allowed`,
            },
        });
    }
    /**
     * Upload a document file
     * Upload a document file (PDF, DOC, DOCX, TXT) to the server. In production, files are stored in S3. In development, files are stored locally.
     * @param formData Document file to upload
     * @returns UploadResponseDto Document uploaded successfully
     * @throws ApiError
     */
    public uploadControllerUploadDocument(
        formData: UploadDocumentDto,
    ): Observable<UploadResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/upload/document',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request - invalid file or file type not allowed`,
            },
        });
    }
}
